/** GxProgress: a labelled count bar ("Forecast made · 2 of 3"). `tone="onNavy"` reads on the navy round band. */
import "./tally.css";

export function GxProgress({ label, done, total, tone = "onNavy", testId, empty, detail }: {
  readonly label: string; readonly done: number; readonly total: number; readonly tone?: "onNavy" | "good"; readonly testId?: string;
  /** Read in place of "n of m" when there is nothing to count ("None this round"). */ readonly empty?: string;
  /** Read in place of "n of m" when the count has parts to name ("1 attested · 1 signed over the risk officer"). */ readonly detail?: string;
}) {
  const share = total === 0 ? 0 : Math.min(1, done / total);
  return (
    <div className="gx-tally gx-num" data-tone={tone} data-testid={testId}>
      <div className="gx-tally-l"><span>{label}</span><b {...(detail !== undefined && !(total === 0 && empty !== undefined) ? { "data-detail": "" } : {})}>{total === 0 && empty !== undefined ? empty : detail ?? `${done} of ${total}`}</b></div>
      <div className="gx-tally-bar" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={total} aria-valuenow={done}><i style={{ width: `${share === 0 ? 2 : share * 100}%` }} /></div>
    </div>
  );
}
